const bootstrapFailureMessage =
  'ChefCollect could not start. Refresh the page to download the application again.';

export function renderBootstrapFailure(error: unknown): void {
  console.error('[Bootstrap] Failed to load the application.', error);

  const root = document.getElementById('root');
  if (!root) {
    return;
  }

  root.setAttribute('role', 'alert');
  root.textContent = bootstrapFailureMessage;
}
